import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { BaseService } from './base.service';
import { ContactUsSM } from '../service-models/contact-us.s-m';
import { ContactUsClient } from '../clients/contact-us.client';
import { ApiResponse } from '../service-models/api-contracts/base/api-response';
import { ApiRequest } from '../service-models/api-contracts/base/api-request';


@Injectable({
  providedIn: 'root'
})
export default class ContactUsService extends BaseService {


  constructor(private contactUsClient:ContactUsClient) { 
    super();
  
  }
  async contactUs(contact: ContactUsSM): Promise<ApiResponse<ContactUsSM>> {
    if (contact == null )// null checks
    {
      throw new Error(AppConstants.ErrorPrompts.Invalid_Input_Data);
    }
    else {
      let apiRequest = new ApiRequest<ContactUsSM>();
      apiRequest.reqData = contact;
      return await this.contactUsClient.AddContactUS(apiRequest);
    }
  }
}
